export const STORE_NAME = 'House of Neyara';

/** Path the admin panel is mounted at in the client. */
export const ADMIN_BASE_PATH = '/superuser-panel';

export const MAX_IMAGES_PER_SAREE = 12;
export const MAX_UPLOAD_BYTES = 15 * 1024 * 1024;
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/avif'] as const;
export type AllowedImageType = (typeof ALLOWED_IMAGE_TYPES)[number];

export const AUTH_COOKIE_NAME = 'neyara_admin';

export const STORE_TAGLINE = 'Timeless Drapes. Eternal You.';
export const INSTAGRAM_HANDLE = 'houseofneyara';

export const SAREE_SORTS = ['newest', 'price-asc', 'price-desc'] as const;
export type SareeSort = (typeof SAREE_SORTS)[number];

/** Stock at or below this (but above zero) counts as "low" in the admin list. */
export const LOW_STOCK_THRESHOLD = 2;
export const ADMIN_STOCK_FILTERS = ['all', 'in-stock', 'low', 'out-of-stock'] as const;
export const ADMIN_SAREE_SORTS = ['updated', 'name', 'stock-asc', 'price-asc', 'price-desc'] as const;
export type AdminSareeSort = (typeof ADMIN_SAREE_SORTS)[number];
